import React from 'react';
import { motion } from 'framer-motion';
import { ClockIcon } from 'lucide-react';
export function UniqueMechanism() {
  return <section className="py-16 md:py-24 bg-gradient-to-br from-sage-primary/20 to-white" data-id="element-135">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-136">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-12" data-id="element-137">
          <div className="inline-flex items-center gap-2 bg-terracotta/10 text-terracotta px-4 py-2 rounded-full mb-4" data-id="element-138">
            <ClockIcon className="w-5 h-5" data-id="element-139" />
            <span className="font-semibold" data-id="element-140">El Secreto</span>
          </div>
          <h2 className="font-serif text-3xl md:text-5xl text-forest mb-6" data-id="element-141">
            La Crono-Sincronización Silver
          </h2>
          <p className="text-xl text-forest/80 max-w-3xl mx-auto leading-relaxed" data-id="element-142">
            El secreto no está en comer menos, sino en alinear tus horarios de
            alimentación con el nuevo ritmo de tus hormonas post-50. Al darle a
            tu cuerpo los nutrientes exactos cuando su sensibilidad a la
            insulina es más alta, logras que use la grasa acumulada como
            combustible en lugar de almacenarla.
          </p>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.2
      }} className="bg-white rounded-2xl shadow-xl p-8 md:p-12" data-id="element-143">
          <h3 className="font-serif text-2xl text-forest mb-8 text-center" data-id="element-144">
            La Ventana de Oro 10/14
          </h3>
          <div className="space-y-6" data-id="element-145">
            <div className="flex items-start gap-4 p-4 bg-sage-primary/10 rounded-lg" data-id="element-146">
              <div className="flex-shrink-0 w-16 h-16 bg-sage-primary rounded-full flex items-center justify-center" data-id="element-147">
                <span className="font-serif text-2xl text-white" data-id="element-148">1</span>
              </div>
              <div data-id="element-149">
                <h4 className="font-semibold text-forest mb-2" data-id="element-150">
                  Desayuno Saciante (8:00 - 9:00 AM)
                </h4>
                <p className="text-forest/70" data-id="element-151">
                  Romper el ayuno con grasas y proteínas para decirle al
                  cerebro: "Hay abundancia, apaga la señal de reserva".
                </p>
              </div>
            </div>

            <div className="flex items-start gap-4 p-4 bg-terracotta/10 rounded-lg" data-id="element-152">
              <div className="flex-shrink-0 w-16 h-16 bg-terracotta rounded-full flex items-center justify-center" data-id="element-153">
                <span className="font-serif text-2xl text-white" data-id="element-154">2</span>
              </div>
              <div data-id="element-155">
                <h4 className="font-semibold text-forest mb-2" data-id="element-156">
                  Almuerzo de Poder (12:00 - 2:00 PM)
                </h4>
                <p className="text-forest/70" data-id="element-157">
                  Aquí es donde entran tus carbohidratos complejos (quinoa,
                  camote, legumbres). Tu cuerpo está en su pico metabólico.
                </p>
              </div>
            </div>

            <div className="flex items-start gap-4 p-4 bg-forest/10 rounded-lg" data-id="element-158">
              <div className="flex-shrink-0 w-16 h-16 bg-forest rounded-full flex items-center justify-center" data-id="element-159">
                <span className="font-serif text-2xl text-white" data-id="element-160">3</span>
              </div>
              <div data-id="element-161">
                <h4 className="font-semibold text-forest mb-2" data-id="element-162">
                  Cena Ligera y Temprana (6:00 - 7:30 PM)
                </h4>
                <p className="text-forest/70" data-id="element-163">
                  Proteína limpia y vegetales verdes. El carbohidrato aquí es
                  mínimo para permitir que la hormona del crecimiento haga su
                  trabajo de quema de grasa mientras duermes.
                </p>
              </div>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}